import { render, staticRenderFns } from "./CatalogHelpIcon.vue?vue&type=template&id=7510828d"
import script from "./CatalogHelpIcon.vue?vue&type=script&lang=ts"
export * from "./CatalogHelpIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports